<template>
    <div class="application-layout">
        <ApplicationHeader />
        <main>
            <slot />
        </main>
        <ApplicationFooter />
        <UNotifications />
    </div>
</template>